import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Loading from "../../../../../../../components/loading/loading";
import {
  getSubdivisionDetailsRequest,
} from "../../../../../../../redux/clients/slice";
import { useDispatch, useSelector } from "react-redux";
import { clientDivisionDeactivateRequest } from "../../../../../../../utils/APICalls";

const styles = {
  container: {
    width: 500,
    maxWidth: 500,
  },
  headerTxt: {
    fontWeight: "540",
    letterSpacing: "0.6px",
    fontSize: 20,
  },
  closeBtn: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
  layout: {
    width: 452,
    mt: -2,
  },
  message: {
    color: "rgba(0, 0, 0, 0.87)",
    mb: 0.5,
  },
  actionBtn: {
    ml: 2,
    mr: 1,
  },
  buttonLayout: {
    mb: 0.5,
  },
  buttonTxt: {
    fontWeight: "510",
    letterSpacing: "0.5px",
    fontSize: 14,
  },
};

export default function DivisionDeactivate({
  showDialog,
  closeDialog,
  id,
  clientId,
}: any) {
  const [loading, setLoading] = useState(false);
  const [divisionList, setDivisionList] = useState<any[]>([]);
  const [selectedDivision, setSelectedDivision] = useState<string>();
  const [error, setError] = useState(false);

  const dispatch = useDispatch();
  const { subDivisionList } = useSelector((state: any) => state?.clients);

  useEffect(() => {
    if (subDivisionList && subDivisionList.length > 0) {
      const filterDivision = subDivisionList.filter(
        (item: any) => item.id !== id
      );
      setDivisionList(filterDivision);
    }
  }, [subDivisionList]); // eslint-disable-line

  const onDivisionChange = (event: SelectChangeEvent) => {
    setError(false);
    setSelectedDivision(event.target.value);
  };

  const deactivateDivision = async () => {
    if (!selectedDivision) {
      setError(true);
      return;
    }
    const payload = {
      orderAssignmentDivisionId: selectedDivision,
    };
    setLoading(true);
    const response = await clientDivisionDeactivateRequest(
      clientId,
      id,
      payload
    );
    setLoading(false);
    if (response?.status === 204) {
      dispatch(getSubdivisionDetailsRequest({ id: clientId, subDivisionId: id }));
      closeDialog();
    }
  };
  return (
    <Dialog
      open={showDialog}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ sx: styles.container }}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography sx={styles.headerTxt}>Deactivate Division?</Typography>
      </DialogTitle>
      <IconButton aria-label="close" onClick={closeDialog} sx={styles.closeBtn}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={styles.layout}>
        <DialogContentText id="alert-dialog-description">
          <Typography sx={styles.message}>
            Are you sure you want to deactivate this division? Any orders
            assigned to this division will be re-assigned to the following
            division:
          </Typography>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label">Division</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Division"
              onChange={onDivisionChange}
            >
              {divisionList.map((item) => (
                <MenuItem value={item.id}>{item.displayName}</MenuItem>
              ))}
            </Select>
            {error && <Typography sx={{fontSize: 12, ml: 1, mt: 0.5}} color="error">This field can't be empty</Typography>}
          </FormControl>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={styles.buttonLayout}>
        <Button variant="contained" onClick={closeDialog}>
          <Typography sx={styles.buttonTxt}>Cancel</Typography>
        </Button>
        <Button
          sx={styles.actionBtn}
          variant="text"
          onClick={deactivateDivision}
          autoFocus
        >
          <Typography sx={styles.buttonTxt}>Deactivate & Re-Assign</Typography>
        </Button>
      </DialogActions>
      {loading && <Loading />}
    </Dialog>
  );
}
